import { render, staticRenderFns } from "./WithWave.vue?vue&type=template&id=04c6b4e4&"
import script from "./WithWave.vue?vue&type=script&lang=js&"
export * from "./WithWave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports